<template>
  <div v-for="(ticket, index) in couponTickets" :key="index">
    <div class="radio">
      <input
        :id="'radio-' + index"
        name="radio"
        type="radio"
        v-model="radioIndex"
        :value="index"
      />
      <label :for="'radio-' + index" class="radio-label">
        {{ ticket.pass_name }}
      </label>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";

export default {
  name: "DbsCouponTicketsRadio",
  props: {
    couponTickets: Array,
    selectedCouponIndex: Number,
  },
  setup(props) {
    const radioIndex = useVModel(props, "selectedCouponIndex");

    return {
      radioIndex,
    };
  },
};
</script>

<style lang="scss" scoped>
.radio-select {
  display: block;
  margin: 1rem;
  font-size: 1.3rem;
}

$color1: #f4f4f4;
$color2: #ff7600;
.margin50 {
  margin: 50px 0;
}
.radio {
  margin: 1rem;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: -0.2em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
